var app = require('../index');

app.fn('siteNav.toggleAccountDropdown', function(e, el) {
	//TEMP
	//until we get redirection to the given URL after login working
	if (!this.model.get('_session.loggedIn')) {
		app.history.push('/login');
		return;
	}

	this.model.set('_page.showAccountDropdown', this.model.get('_page.showAccountDropdown') ? false: true);
});

//also close the dropdown if user clicks outside of it

//Never mind below comment - jQuery workaround didn't work (prevented menu from working at all)
//Using jQuery for now (see app.enter callback); adding x-bind to <body> causes "Uncaught Error: Server and client page renders do not match"

app.fn('siteNav.bodyClick', function(e, el) {
	if (el.id != 'toggle-account-dropdown-link')
		this.model.set('_page.showAccountDropdown', false);
});